const i18nList = [
  { lng: 'zh_CN', name: '中文' },
  { lng: 'en_US', name: 'English' },
  { lng: 'ja_JP', name: '日本語' }
];

export default i18nList;
